import { computed } from 'vue'

import { useLocalization } from '@/shared/composables/localization'
import { getTextForDifferentCount } from '@/shared/utils/get-text-for-different-count'

const wordsForMessages = computed(() => {
  const { tc } = useLocalization()
  return {
    forOne: tc('common.messageP', 0),
    forTwo: tc('common.messageP', 1),
    forFive: tc('common.messageP', 2),
  }
})

export const countMessagesText = (length: number) => getTextForDifferentCount(length, wordsForMessages.value)
export * from './bulk-delete-messages'
export * from './unread-messages'
export * from './read-marks-for-display'
